<template>
  <div class="LC_quota" ref="LC_quota">
    <div class="upWrap" v-if="!isVisit">
      <div class="upLeft">
        <div class="textBox">{{dataObj?.year}}年
          碳履约期还剩</div>
      </div>
      <div class="upRight">
        <div class="timeNum">
          <div class="countDown number">
            <span>{{getDays(0)}}</span>
            <span>{{getDays(1)}}</span>
            <span>{{getDays(2)}}</span>
          </div>
        </div>
        <div class="dayText">天</div>
      </div>
    </div>
    <div class="downWrap" :class="{'downWrap-visit': isVisit}">
      <div class="downWrap-item" style="cursor:pointer" @click="openDetail()">
        <div class="item-title">
          当前碳排放量
        </div>
        <div class="main-box">
          <div class="item-main-left">
            <div class="item-main-left-line1">
              <div class="line1-name">配额使用比例</div>
              <div class="line1-value">{{parseInt(dataObj.usePercent*100)+'%'}}</div>
            </div>
            <div class="item-main-left-line2">
              <div :style="{width: getWidth(dataObj.usePercent*100)[0]+'%',maxWidth:'100%'}" class="line-process"></div>
              <div :style="{width: getWidth(dataObj.usePercent*100)[1]+'%',maxWidth:'100%'}" class="line-process2"></div>
            </div>
          </div>
          <div class="item-main-right">
            <span class="dinBold">
              <number-scroll-component :totalData="dataObj.consumption&&Number(dataObj.consumption.toFixed(2))" :symbolIndex="0" symbol="symbol2" height="56px" top="0px" letterSpacing="10px"
                duration="2s" />
            </span> 万吨
            <!-- <span class="dinBold">{{dataObj.consumption&&Number(dataObj.consumption).toFixed(2)}}</span> 万吨 -->
          </div>
        </div>
      </div>
      <div class="downWrap-item">
        <div class="item-title">
          预测年碳排放量
        </div>
        <div class="main-box">
          <div class="item-main-left">
            <div class="item-main-left-line1">
              <div class="line1-name">预测年配额使用比例</div>
              <div class="line1-value">{{parseInt(dataObj.usePercentYear*100)+'%'}}</div>
            </div>
            <div class="item-main-left-line2">
              <div :style="{width:  getWidth(dataObj.usePercentYear*100)[0]+'%',maxWidth:'100%'}" class="line-process"></div>
              <div :style="{width:  getWidth(dataObj.usePercentYear*100)[1]+'%',maxWidth:'100%'}" class="line-process2"></div>
            </div>
          </div>
          <div class="item-main-right">
            <span class="dinBold">
              <!-- <number-scroll-component :totalData="dataObj.forecastAnnual&&Number(dataObj.forecastAnnual.toFixed(2))" :symbolIndex="1" symbol="symbol2" height="56px" top="0px" letterSpacing="10px"
                duration="1s" /> -->
              <number-scroll-component :totalData="dataObj.forecastAnnual&&Number(dataObj.forecastAnnual.toFixed(2))" :symbolIndex="1" symbol="symbol2" height="56px" top="0px" letterSpacing="10px"
                duration="2s" />
            </span> 万吨
            <!-- <span class="dinBold">{{dataObj.forecastAnnual&&Number(dataObj.forecastAnnual).toFixed(2)}}</span> 万吨 -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import detailPage from "./components/quotaDetailPage.vue";
import NumberScrollComponent from "@/modules/DIYcomponents/components/2_2/LC_procedure/numberScrollComponent_.vue";
import { mapGetters } from "vuex";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { NumberScrollComponent },
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'LC_quota.vue',
      computedName: '碳排放总览组件',
      customerId: this.$store.state.customerId,
      timer2: null,
      dataObj: {},
      width1: 0,
      width2: 0,
      // test: 152.01,
      // testTimer:null
    };
  },
  //计算属性 类似于data概念
  computed: {
    getDays() {
      return (i) => {
        let days = this.dataObj.days;
        if (!days) {
          return 0;
        } else {
          if (days < 10) {
            days = "00" + days;
          } else if (days < 100) {
            days = "0" + days;
          } else {
            days = "" + days;
          }
          let dayArr = days.split("");
          return dayArr[i];
        }
      };
    },
    getWidth() {
      return (i) => {
        if (!i) return [0, 0];
        i = Number(i);
        let widthGreen = 0;
        let widthRed = 0;
        if (i < 100) {
          widthGreen = i;
          widthRed = 0;
        } else {
          widthGreen = 100;
          widthRed = i - 100;
        }
        return [widthGreen, widthRed];
      };
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    isVisit() {
      return this.$store.state.isVisit
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.LC_quota).outerWidth();
    let h = $(that.$refs.LC_quota).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
    // this.testTimer = setInterval(() => {
    //   this.test += 1;
    // }, 5000);
  },
  unmounted() {
    if (this.timer2) {
      clearTimeout(this.timer2);
      this.timer2 = null;
    }
  },
  //方法集合
  methods: {
    async getListData() {
      if (this.timer2) {
        clearTimeout(this.timer2);
        this.timer2 = null;
      }
      try {
        const carbonUseSituation =
          CONFIG.requestName + this.$apiOpt.carbonUseSituation;
        let res = await this.$apiUtils.get(carbonUseSituation, {
          customerId: this.customerId,
        });
        this.dataObj = res;
      } catch (err) {
        console.log(err);
      }
      this.timer2 = setTimeout(() => {
        this.getListData();
      }, 1000 * 30);
    },
    openDetail() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(detailPage, this.dialogCompontent,{pageTitleName: '当前碳排放量'});
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
// @import url("./css/style.scss");
.LC_quota {
  width: 600px;
  height: 520px;
  padding-top: 66px !important;
  .upWrap {
    width: 100%;
    height: 178px;
    background: linear-gradient(
      180deg,
      rgba(108, 151, 255, 0.2) 0%,
      rgba(107, 151, 255, 0.2) 48%,
      rgba(58, 116, 255, 0.1) 100%,
      #0049fa 100%,
      #0049fa 100%
    );
    border: 1px solid rgba(38, 76, 169, 0.53);
    margin-bottom: 16px;
    display: flex;
    .upLeft {
      flex: 1;
      padding: 29px 18px;
      .textBox {
        width: 246px;
        height: 120px;
        background: linear-gradient(
          224deg,
          rgba(52, 41, 93, 0.25) 0%,
          rgba(33, 41, 76, 0.25) 100%
        );
        border-radius: 4px;
        border: 1px solid #406efc;
        font-size: 30px;
        font-weight: 500;
        color: #e2effd;
        line-height: 42px;
        padding: 15px 26px;
        text-align: center;
      }
    }
    .upRight {
      flex: 1;
      padding: 29px 23px;
      display: flex;
      align-items: flex-end;
      .timeNum {
        @include bg-box(208px, 120px, "numberBg.png");
        .countDown {
          font-size: 80px;
          font-weight: 400;
          color: #ffc566;
          line-height: 120px;
          span {
            width: 66px;
            display: inline-block;
            text-align: center;
            margin-right: 5px;
          }
          span:nth-last-child(1) {
            margin-right: 0px;
          }
        }
      }
      .dayText {
        width: 20px;
        height: 28px;
        font-size: 20px;
        font-weight: 500;
        color: #e2effd;
        line-height: 28px;
      }
    }
  }
  .downWrap {
    width: 100%;
    height: 242px;
    background: #6c97ff30;
    border: 1px solid rgba(38, 76, 169, 0.53);
    .downWrap-item {
      height: 50%;
      padding: 15px;
      &:nth-child(1) {
        border-bottom: 1px solid rgba(38, 76, 169, 0.53);
      }
      .item-title {
        font-size: 18px;
        font-weight: 500;
        color: #e2effd;
        line-height: 18px;
        margin-bottom: 15px;
      }
      .main-box {
        display: flex;
        justify-content: space-between;
        .item-main-left {
          flex: 1;
          .item-main-left-line1 {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            line-height: 16px;
            margin-bottom: 10px;
            position: relative;
          }
          .line1-name,
          .line1-value {
            font-size: 16px;
            line-height: 16px;
          }
          .item-main-left-line2 {
            position: relative;
            width: 285px;
            height: 29px;
            background: #2f1e02;
            border: 1px solid rgba(0, 0, 0, 0.82);
            .line-process {
              height: 100%;
              background: #7ff4b1;
            }
            .line-process2 {
              height: 100%;
              background: red;
              position: absolute;
              top: 0;
              right: 0;
            }
          }
        }
        .item-main-right {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          padding-left: 40px;
          height: 56px;
          font-size: 16px;
          font-weight: 600;
          color: #fff2dc;
          line-height: 16px;
          span {
            flex: 1;
            font-size: 56px;
            height: 56px;
            font-weight: bold;
            color: #fff2dc;
            line-height: 56px;
          }
        }
      }
    }
  }
  .downWrap-visit {
    height: 420px;
    .downWrap-item {
      padding: 30px 15px;
      .item-title {
        margin-bottom: 20px;
      }
      // .main-box .item-main-left .item-main-left-line1 {
      //   margin-bottom: 30px;
      // }
    }
  }
}
</style>
